import { SavedAttribute } from '../saved/saved-attribute.type';
import { SavedTable } from '../saved/saved-table.type';
import { ToCreateAttribute } from '../to-create/to-create-attribute.type';
import { ToCreateTable } from '../to-create/to-create-table.type';
import { Attribute } from './attribute.class';

export class Table {
  private _id?: number;
  private _title: string;
  private _attributeList: Attribute[];
  private _databaseModelId?: number;

  constructor(title: string, attributeList: Attribute[] = []) {
    this._title = title;
    this._attributeList = attributeList;
  }

  public static mapFromSaved(savedTable: SavedTable): Table {
    const attributeList: Attribute[] = savedTable.attributeList.map((savedAttribute: SavedAttribute) => Attribute.mapFromSaved(savedAttribute));
    const table = new Table(savedTable.title, attributeList);
    table._id = savedTable.id;
    table._databaseModelId = savedTable.databaseModelId;
    return table;
  }

  public static mapToSaved(table: Table): SavedTable {
    return {
      id: table._id as number,
      title: table._title,
      attributeList: table._attributeList.map(attribute => Attribute.mapToSaved(attribute)),
      databaseModelId: table._databaseModelId as number,
    };
  }

  public static mapToCreate(table: Table): ToCreateTable {
    const attributeList: ToCreateAttribute[] = table._attributeList.map((attribute: Attribute) => Attribute.mapToToCreate(attribute));
    return {
      title: table._title,
      attributeList: attributeList,
    };
  }

  public getDatabaseModelId(): number | undefined {
    return this._databaseModelId;
  }

  public setDatabaseModelId(id?: number): Table {
    this._databaseModelId = id;
    return this;
  }

  public getTitle(): string {
    return this._title;
  }

  public getAttributeList(): Attribute[] {
    return this._attributeList;
  }
}
